/**
 * Каналы раздела «Сообщения» администратора.
 *
 * До 2026-08-22 их было два разных раздела: `/admin/chat` (объявления и
 * переписка с представителями) и `/admin/support` (инбокс обращений) — с
 * одной иконкой на оба пункта меню. Владелец попросил объединить и привести к
 * виду участника, поэтому каналы теперь лежат в одном рельсе.
 */
export const AdminChannel = {
  announcements: 'announcements',
  representatives: 'representatives',
  support: 'support',
} as const
export type AdminChannel = (typeof AdminChannel)[keyof typeof AdminChannel]

/** Значение из адреса — канал? Неизвестное игнорируем: `?channel=` приходит
 *  извне, и падать из-за опечатки в ссылке раздел не должен. */
export function isAdminChannel(value: string | null): value is AdminChannel {
  return value !== null && Object.values<string>(AdminChannel).includes(value)
}
